/* FeaturedCard.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _22 = "._4cvr1h6o{align-items:center}";
const _21 = "._1bah1h6o{justify-content:center}";
const _20 = "._1e0c1txw{display:flex}";
const _19 = "._18u01wug{margin-left:auto}";
const _18 = "._otyridpf{margin-bottom:0}";
const _17 = "._2hwx1wug{margin-right:auto}";
const _16 = "._19pkidpf{margin-top:0}";
const _15 = "._1bsb11ux{width:140px}";
const _14 = "._4t3i11ux{height:140px}";
const _13 = "._qrwq7vkz{border-top-right-radius:1pc}";
const _12 = "._13li7vkz{border-top-left-radius:1pc}";
const _11 = "._1yt4hiv4{padding:var(--ds-space-400)}";
const _10 = "._1ejj17er:focus-visible{box-shadow:var(--ds-shadow-overlay)}";
const _9 = "._1lwi4suz:focus-visible{border:2px solid var(--ds-border-focused)}";
const _8 = "._1di617i0:active{background-color:var(--ds-surface-raised-hovered)}";
const _7 = "._1dbz17er:hover{box-shadow:var(--ds-shadow-overlay)}";
const _6 = "._19it7v06{border:1px solid var(--ds-border)}";
const _5 = "._bfhk143w{background-color:var(--ds-surface-raised)}";
const _4 = "._80omtlke{cursor:pointer}";
const _3 = "._2rko7vkz{border-radius:1pc}";
import { BodySmall, H4 } from '@atlassian/mpac-primitives';
import React from 'react';
const _2 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _ = "._19pk1eps{margin-top:var(--ds-space-100)}";
const Description = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pk1eps _syaz1k3w", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
const Card = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4, _5, _6, _7, _8, _9, _10]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_2rko7vkz _80omtlke _bfhk143w _19it7v06 _1dbz17er _1di617i0 _1lwi4suz _1ejj17er", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Card.displayName = 'Card';
}
const ContentWrapper = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_11]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1yt4hiv4", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ContentWrapper.displayName = 'ContentWrapper';
}
const ImageContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_11, _12, _13]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1yt4hiv4 _13li7vkz _qrwq7vkz", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ImageContainer.displayName = 'ImageContainer';
}
const ImageWrapper = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_14, _15, _16, _17, _18, _19, _20, _21, _22]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_4t3i11ux _1bsb11ux _19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _1bah1h6o _4cvr1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ImageWrapper.displayName = 'ImageWrapper';
}
export const FeaturedCard = _ref6 => {
  let {
    title,
    description,
    image,
    backgroundColor
  } = _ref6;
  return /*#__PURE__*/React.createElement(Card, {
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    style: {
      backgroundColor
    }
  }, /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: title
  }))), /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(H4, null, title), /*#__PURE__*/React.createElement(Description, null, description)));
};